import { z } from 'zod';
import { moneySchema } from '../money';

/** Länge der Top-Listen (Lagerwert je Warengruppe, größte Unterdeckung). */
export const STOCK_SUMMARY_TOP = 6;

/**
 * Lager-Kennzahlen über ALLE Artikel der Standardliste (ohne Ablängungen) —
 * Analyse-Cockpit, serverseitig gerechnet (2026-09-29). Vorher summierte der
 * Browser die ersten 200 Artikel.
 *
 * Lagerwert je Zeile nach `stockValueMicros` (EK ▸ letzter EK ▸ VK), dieselbe
 * Regel wie die Artikel- & Lager-Analyse. Werte nur mit `inventory.viewprices`
 * — sonst `null` (wie die Preise in der Artikelliste), nie 0.
 */
export const stockSummarySchema = z.object({
  asOf: z.string().datetime(),
  /** Gesamter Lagerwert; `null` ohne `inventory.viewprices`. */
  stockValue: moneySchema.nullable(),
  /** Lagerwert je Warengruppe (Top, > 0, absteigend); `null` ohne `inventory.viewprices`. */
  valueByCommodityGroup: z
    .array(
      z.object({
        /** Warengruppe (4-stellig, ADR 0016); `null` = ohne Warengruppe. */
        commodityGroup: z.number().int().nullable(),
        value: moneySchema,
      }),
    )
    .nullable(),
  /** Größte Unterdeckung: Fehlmenge bis zum Mindestbestand (Top, absteigend). */
  largestShortfalls: z.array(
    z.object({
      articleId: z.string().uuid(),
      number: z.string(),
      name: z.string(),
      shortfallQty: z.number().positive(),
    }),
  ),
});
export type StockSummary = z.infer<typeof stockSummarySchema>;
